import { Upselling } from 'services/api/entities/catalog/upselling/types/internal/upselling-models'
import { EntityDescriptor } from '.'
import { formatExperienceUpselling } from './common'

export const physicalupselling: EntityDescriptor<Upselling> = {
  format: formatExperienceUpselling,
}
